import React, {
  useEffect,
  useState
} from "react";

import {
  Link
} from "react-router-dom";

import "../App.css";

import {
  apiUrl
} from "../config/apiBase";

import logoLight
  from "../obr/FCA_App_black2.png";

import logoDark
  from "../obr/FCA_App_gold2.png";

export default function ZabudnuteHeslo() {
  const [
    email,
    setEmail
  ] =
    useState("");

  const [
    err,
    setErr
  ] =
    useState("");

  const [
    ok,
    setOk
  ] =
    useState("");

  const [
    odosielam,
    setOdosielam
  ] =
    useState(false);

  const nacitajTemu = () => {
    const ulozena =
      localStorage.getItem(
        "tema"
      );

    return ulozena ===
      "dark"
      ? "dark"
      : "light";
  };

  const [tema] =
    useState(
      nacitajTemu
    );

  const aktualneLogo =
    tema === "light"
      ? logoLight
      : logoDark;

  useEffect(() => {
    document.documentElement
      .setAttribute(
        "data-theme",
        tema
      );
  }, [tema]);

  const onSubmit =
    async (e) => {
      e.preventDefault();

      if (odosielam) {
        return;
      }

      setErr("");
      setOk("");
      setOdosielam(true);

      try {
        const r =
          await fetch(
            apiUrl(
              "/api/auth/zabudnute-heslo"
            ),
            {
              method:
                "POST",

              headers: {
                "Content-Type":
                  "application/json"
              },

              body:
                JSON.stringify({
                  email
                })
            }
          );

        const data =
          await r
            .json()
            .catch(
              () => ({})
            );

        if (!r.ok) {
          throw new Error(
            data?.message ||
              "Obnovenie hesla sa nepodarilo spracovať."
          );
        }

        setOk(
          data?.message ||
            "Ak účet existuje, poslali sme pokyny na zadaný email."
        );

      } catch (e2) {
        setErr(
          e2.message ||
            "Obnovenie hesla sa nepodarilo spracovať."
        );
      } finally {
        setOdosielam(
          false
        );
      }
    };

  return (
    <div className="login-page">
      <div className="login-shell">

        <div className="login-logo-wrap">
          <img
            src={aktualneLogo}
            alt="FinCloud"
            className="login-logo"
          />
        </div>

        <div className="App login-app">
          <div className="card-section login-card">

            <h2>
              Obnovenie hesla
            </h2>

            <form
              onSubmit={onSubmit}
              className="form-group"
            >
              <div className="form form--full">

                <label className="form_label">
                  Email
                </label>

                <input
                  className="form_input"
                  type="email"
                  value={email}
                  onChange={
                    (e) =>
                      setEmail(
                        e.target.value
                      )
                  }
                  required
                />

                {err && (
                  <div className="form_hint error">
                    {err}
                  </div>
                )}

                {ok && (
                  <div className="form_hint">
                    {ok}
                  </div>
                )}

              </div>

              <div className="form-actions form-actions--full">

                <button
                  type="submit"
                  className="form_input action-btn"
                  disabled={
                    odosielam
                  }
                >
                  {odosielam
                    ? "Odosielam..."
                    : "Odoslať pokyny"}
                </button>

                <Link
                  to="/login"
                  className="login-forgot-link"
                >
                  Späť na prihlásenie
                </Link>

              </div>

            </form>

          </div>
        </div>

      </div>
    </div>
  );
}